<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T21:47:30+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2018-02-05T17:36:52+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:
  <uli
    labelkey="intro.item">
  </uli>
  // this assumes intro.item.1 and so on till maximum .10

or:
  <uli
    :nritems='4'
    color="info"
    icon="check"
    button
    outline
    horizontal
    size=""
    labelkey="intro.list"
    tooltipkey="intro.tooltip">
  </uli>

-->

<template>
  <ul v-if="$te(labelkey, 'en')" class="uli">
    <lii
      v-for="i in nritems"
      :key="i"
      :icon="(i===1 && hidefirst) ? '' : icon"
      :color="color"
      :horizontal="horizontal"
      :button="button"
      :outline="outline"
      :size="size"
      :label="$te(labelkey + '.' + i) ? $t(labelkey + '.' + i) : ''"
      :tooltip="$te(tooltipkey + '.' + i, 'en') ? $t(tooltipkey + '.' + i) : ''"
    />
  </ul>
</template>

<script>
export default {
  name: 'Uli',
  props: {
    nritems: {
      type: Number, // use like :nritems ='5'
      default: 10
    },
    icon: {
      type: String, // fontawesome key: "plus", "check", "user-o",...
      default: 'check'
    },
    hidefirst: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String, // Bootstrap button size: "sm", "" or "lg"
      default: 'sm'
    },
    color: {
      type: String,
      default: ''
    },
    labelkey: {
      type: String,
      default: '**Missing v18n label key**'
    },
    tooltipkey: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
  .uli {
    padding: 0;
    list-style-type: none !important;

    position: relative;
    font-size: 0.9em;
    line-height: 1.2em;
  }

</style>
